import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';
import { getLayoutType } from '../../../utilities/get-layout-type.esm.js';
import { getLayoutById } from '../../../utilities/get-layout-by-id.esm.js';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';
import { selectDefaultLayout } from '../../../utilities/select-default-layout.esm.js';
import { applyLayout } from '../../../utilities/apply-layout.esm.js';

function getResetCallback(layouts, displayLayouts, setDisplayLayouts) {
  return function () {
    var displayLayout = getSelectedLayout(displayLayouts);
    var displayLayoutType = getLayoutType(displayLayout);
    switch (displayLayoutType) {
      case LayoutType.Default:
      case LayoutType.Custom:
      case LayoutType.Predefined:
        {
          var newDisplayLayouts = selectDefaultLayout(displayLayouts);
          if (newDisplayLayouts !== displayLayouts) {
            setDisplayLayouts(newDisplayLayouts);
          }
        }
        return;
      case LayoutType.Saved:
        {
          var currentLayout = getLayoutById(layouts, displayLayout.id);
          var _newDisplayLayouts = selectDefaultLayout(applyLayout(displayLayouts, currentLayout));
          if (_newDisplayLayouts !== displayLayouts) {
            setDisplayLayouts(_newDisplayLayouts);
          }
        }
        return;
      default:
        throw new Error('Invalid type');
    }
  };
}
var createResetCallbackSelector = function createResetCallbackSelector() {
  return createSelector(function (props) {
    return props.layouts;
  }, function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.setDisplayLayouts;
  }, getResetCallback);
};

export { createResetCallbackSelector, getResetCallback };
//# sourceMappingURL=reset-callback-selector.esm.js.map
